import { Environment } from '@diritto/common/base/constants';

export const configure = {
  environment: (process.env.NEXT_PUBLIC_ENVIRONMENT as Environment) || Environment.Local,
  rootDomain: process.env.NEXT_PUBLIC_BASE_DOMAIN || process.env.VERCEL_URL,
  serviceDomain: process.env.NEXT_PUBLIC_BASE_DOMAIN || process.env.VERCEL_URL,
  serviceUrl: process.env.NEXT_PUBLIC_DIRITTO_URL || '',
  apiPublicUrl: process.env.NEXT_PUBLIC_API_PUBLIC_URL,
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  cdnPublicUrl: process.env.NEXT_PUBLIC_CDN_PUBLIC_ENDPOINT,
  cdnUrl: process.env.NEXT_PUBLIC_CDN_PUBLIC_PROXY_ENDPOINT,
  privateCdnPublicUrl: process.env.NEXT_PUBLIC_CDN_PRIVATE_ENDPOINT,
  privateCdnUrl: process.env.NEXT_PUBLIC_CDN_PRIVATE_PROXY_ENDPOINT,
  dynamicCdnPublicUrl: process.env.NEXT_PUBLIC_CDN_DYNAMIC_ENDPOINT,
  dynamicCdnUrl: process.env.NEXT_PUBLIC_CDN_DYNAMIC_PROXY_ENDPOINT,
  drawKitUrl: process.env.NEXT_PUBLIC_DRAWKIT_URL,
  shortUrl: process.env.NEXT_PUBLIC_SHORT_URL,
  isLocal: process.env.NEXT_PUBLIC_ENVIRONMENT === Environment.Local,
  isDev: process.env.NEXT_PUBLIC_ENVIRONMENT === Environment.Development,
  isProd: process.env.NEXT_PUBLIC_ENVIRONMENT === Environment.Production,
  staticPrefix: process.env.NEXT_PUBLIC_STATIC_PREFIX || '',
};
